<template>
  <div class="box">
    <service-tile
      v-for="service in docs"
      :key="service._id"
      :service="service"
    ></service-tile>
  </div>
</template>
<script>
import ServiceTile from "./service-tile";
export default {
  components: { ServiceTile },
  computed: {
    docs() {
      let component = this;
      return component.$store.getters["service/docs"];
    }
  },
  mounted() {
    let component = this;
    component.$store.dispatch("service/index");
  }
};
</script>
